<template>
  <no-ssr>
    <div class="layout-header">
      <div class="header-index-left">
        <span class="header-index-action" style="float: left">
          <div @click="toggleMenu">
            <Icon :style="{ transform: toggle ? 'rotate(90deg)' : '' }" style type="md-menu" size="20" />
          </div>
        </span>
      </div>
      <div class="header-index-right">
        <a @click="goGaoBao" v-if="t.name">返回报考</a>
        <!--<span style="font-size: 12px;" @click="message">最新消息</span>
         <span style="fon-size: 12px; margin-right: 5px" @click="message">{{totalUnreadCount}}</span> -->
        <span @click="noticeClick" v-if="unreadNoticeCount == 0">系统通知</span>
        <span @click="noticeClick" v-if="unreadNoticeCount == 0">{{unreadNoticeCount}}</span>
        <span style="font-size: 12px; color:red" @click="noticeClick" v-if="unreadNoticeCount > 0">系统通知</span>
        <span style="fon-size: 12px; margin-right: 5px;color:red" @click="noticeClick" v-if="unreadNoticeCount > 0">{{unreadNoticeCount}}</span>
        <span class="header-index-action">
          <Dropdown placement="bottom">
            <Avatar size="small" style="background-color: #87d068" icon="ios-person" />
            <span class="header-index-name">{{$store.state.app.userInfo.realName}}</span>
            <DropdownMenu slot="list">
              <DropdownItem>
                <div style="width: 100%" @click="goAccount">
                  <Icon type="md-settings" size="18" />
                  <span>个人中心</span>
                </div>
              </DropdownItem>
              <DropdownItem divided>
                <div style="width: 100%" @click="logout">
                  <Icon type="md-power" size="18" />
                  <span>退出登录</span>
                </div>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </span>
        <messageNoticeAdmin v-if="isRoute" @tableReload="tableReload" ref="messageNoticeAdmin"></messageNoticeAdmin>
      </div>
      <el-dialog :visible="resetPasswordVisible" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" width="500px">
        <p style="padding: 0px; margin-left: 16px; color: red">
<!--          {{ user?.resetPasswordFlag != 1 ? '需要进行密码调整，如果尚未进行过密码修改，则原密码可能为123456或Aa123456，请修改密码后使用该系统' : '需要进行密码调整' }}-->
          需要进行密码调整，如果尚未进行过密码修改，则原密码可能为123456或Aa123456
        </p>
        <Form @submit.native.prevent loading="formLoading" style="padding: 0px 16px" ref="updatePasswordForm" :model="updatePasswordForm" :label-width="80" :rules="passwordRules">
          <FormItem label="旧密码：" prop="oldPassword">
            <Input v-model="updatePasswordForm.oldPassword" type="password" />
          </FormItem>
          <FormItem label="新密码：" prop="password">
            <Input v-model="updatePasswordForm.password" type="password" placeholder="新密码必须包含大小写英文和数字及符号，且必须8位及以上" />
          </FormItem>
          <FormItem label="确认密码" prop="checkPass">
            <Input class="form-input" v-model="updatePasswordForm.checkPass" type="password" placeholder="请再次输入新密码"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updatePassword">保存</Button>
          </FormItem>
        </Form>
      </el-dialog>
      <div v-if="reLogin" class="modal-self">
        <div class="modal-content-wrap">
          <p class="title">提示</p>
          <div class="content">当前登录状态已失效，请重新登录。</div>
          <div class="btn-wrap">
            <el-button class="btn-confirm" type="primary" @click="toLogin()">确定</el-button>
          </div>
        </div>
      </div>
    </div>
  </no-ssr>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import Cookie from "js-cookie";
import messageNoticeAdmin from "~/components/WorkBench/messageNoticeAdmin";
import Format from "~/plugins/format.js";
import {_baseUrl} from "@/plugins/request";
export default {
  components: {
    messageNoticeAdmin
  },
  computed: {
    // ["userInfo"]
    ...mapState({
      totalUnreadCount: state => {
        // console.log(state.im.conversation.totalUnreadCount);
        let conversationList = state.im.conversation.conversationList;
        let count = 0;
        for (let item of conversationList) {
          count += item.unreadCount;
        }
        return count;
      }
    })
  },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.updatePasswordForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      // var reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/
      const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
      if (!value) {
        callback(new Error('请输入新密码'));
      } else if (!reg.test(value)) {
        callback(new Error('新密码必须包含大小写英文和数字及符号，且必须8位及以上'));
      } else {
        callback()
      }
    }
    return {
      user: {},
      showPassword: false,
      unreadNoticeCount:0,
      resetPasswordVisible: false,
      isRoute: false,
      unreadCount: 0,
      currentUserID: "",
      currentTab: "",
      NoticeCount: 0,
      poptipShow: false,
      updatePasswordForm: {},
      formLoading: false,
      t: {

      },
      passwordRules: {
        oldPassword: [
          {
            required: true,
            message: "请输入旧密码",
            trigger: "blur"
          },
          {
            type: "string",
            max: 15,
            message: "旧密码长度不能大于15位",
            trigger: "blur"
          },
          {
            validator: Format.FormValidate.Form().Space,
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            validator: validatePassword,
            trigger: "blur"
          },
          {
            validator: Format.FormValidate.Form().Space,
            trigger: "blur"
          }
        ],
        checkPass: [
          {
            required: true,
            validator: validatePassCheck,
            trigger: "blur"
          },
        ],
      },
      notifList: [
        { label: "系统通知", name: "2" },
        { label: "审批通知", name: "0" },
        { label: "服务通知", name: "1" }
      ],
      systemMessages: [], //系统消息
      serveMessages: [], //服务消息
      approveMessages: [], //审批消息
      socket: null,
      reConnectCount: 0,
      timer: null,
      reLogin: false,
    };
  },
  created() {
    this.$root.$on("messageNoticeCount", () => {
      this.getMessageNoticeCount();
    });
  },
  distroyed() {
    this.$root.$off("messageNoticeCount");
  },
  methods: {
    goGaoBao() {
      let tStr = sessionStorage.getItem('pathForReturnRegistion')
      const t = JSON.parse(tStr)
      this.$router.push({
        name: t.name,
        query: t.query,
        params: t.params
      });
    },
    message() {
      const { href } = this.$router.resolve({
        name: "im"
      });
      window.open(href, "_blank");
    },
    noticeClick(){
       this.$router.push("/noticeOnline")
    },
    selectNoReadMessageCount(){
      this.$store
          .dispatch("noticeOnline/selectNoReadMessageCount", {})
          .then(res => {
            this.unreadNoticeCount = res
          })
          .catch(error => {

          });
    },
    updatePassword() {
      this.$refs.updatePasswordForm.validate(valid => {
        if (valid) {
          this.formLoading = true;
          this.$store.dispatch("app/updatePassword", this.updatePasswordForm).then(res => {
            this.resetPasswordVisible = false;
            this.formLoading = false;
            this.updatePasswordForm = {};
            this.$store.dispatch("app/getUserInfo");
            this.$Message.success("操作成功");
          }).catch(error => {
            this.formLoading = false;
            this.$message({
              message: error.message,
              type: "error",
              duration: 1500
            });
          });
        }
      });
    },
    getMessageNoticeCount() {
      //获取未读消息总数
      this.$store.dispatch("message/selectUserId", {}).then(res => {
        this.currentUserID = res;
        this.$store.dispatch("message/getMessageNoticeCount", {
          userID: this.currentUserID
        }).then(res => {
          this.NoticeCount = res;
          this.approveMessages = [];
          this.serveMessages = [];
          this.systemMessages = [];
          this.$store.dispatch("message/selectMessagesService", {}).then(res => {
            for (var i = 0; i < res.length; i++) {
              if (res[i].messageType == 0) {
                this.approveMessages.push(res[i]);
              } else if (res[i].messageType == 1) {
                this.serveMessages.push(res[i]);
              } else if (res[i].messageType == 2) {
                this.systemMessages.push(res[i]);
              }
            }
          }).catch(error => {
            this.$Message.warning(error.message);
          });
        }).catch(error => {
          this.$Message.warning(error.message);
        });
      }).catch(error => {
        this.$Message.warning(error.message);
      });
    },
    toggleMenu() {
      this.$store.commit("route/SET_TOGGLE", null);
    },
    openPoptip() {
      this.currentTab = "2";
      this.$store.dispatch("message/getMessageNoticeCount", {
        userID: this.currentUserID
      }).then(res => {
        this.NoticeCount = res; //该消息的信息
        this.approveMessages = [];
        this.serveMessages = [];
        this.systemMessages = [];
        this.$store.dispatch("message/selectMessagesService", {}).then(res => {
          for (var i = 0; i < res.length; i++) {
            if (res[i].messageType == 0) {
              this.approveMessages.push(res[i]);
            } else if (res[i].messageType == 1) {
              this.serveMessages.push(res[i]);
            } else if (res[i].messageType == 2) {
              this.systemMessages.push(res[i]);
            }
          }
        }).catch(error => {
          this.$Message.warning(error.message);
        });
      }).catch(error => {
        this.$Message.warning(error.message);
      });
    },
    getMessage() { },
    clickTabs(name) { },
    linkgo(url) {
      this.poptipShow = false;
      if (this.$route.name == url.operateUri && this.$route.name != "index-workbench-myToDo") {
        this.isRoute = true;
        this.$nextTick(() => {
          this.$refs.messageNoticeAdmin.updateMessage(url.messageServiceId, url.messageType, false, 0, 1, url.status);
        });
      } else {
        this.$router.push({
          name: url.operateUri,
          params: {
            news: true,
            messageId: url.messageServiceId,
            type: url.messageType,
            status: url.status
          }
        });
      }
      this.$store.dispatch("message/updateMessagesServiceStatus", {
        messageId: url.messageServiceId,
        messageType: url.messageType
      }).then(res => {
        this.$root.$emit("messageNoticeCount");
      }).catch(error => {
        this.$Message.warning(error.message);
      });
    },
    logout() {
      this.$Modal.confirm({
        title: "确认提示",
        content: "<p>是否退出登录</p>",
        onOk: () => {
          this.$store.dispatch("app/logout").then(() => {
            this.$router.push("/login");
          }).catch(() => {
            this.$router.push("/login");
          });
        }
      });
    },
    goAccount() {
      this.$router.push("/account");
    },
    messageClear() {
      this.$Modal.confirm({
        title: "确认提示",
        content: "<p>是否清空消息</p>",
        onOk: () => {
          this.$store.dispatch("message/messageClear", {
            receiveUserId: this.currentUserID
          }).then(() => {
            this.$forceUpdate();
            this.$Message.warning("成功");
          }).catch(() => {
            this.$Message.warning("操作失败");
          });
        }
      });
    },
    getLogoutMessage() {
      let url = _baseUrl;
      this.url = url.replace("http://", "").replace("https://", "");
      let token = Cookie.get("token");
      let userInfo = JSON.parse(Cookie.get("userInfo"))
      let userId = userInfo.userId
      if (!userId || !token) {
        return
      }
      let sessionKey = userId + "_" + token + "_" + Date.now()
      let wsUrl = `wss://${this.url}socketForLoginServer/login/${sessionKey}`
      this.socket = new WebSocket(wsUrl);
      const _this = this;
      this.socket.onmessage = function (event) {
        let message = event.data;
        if (message == "logout") {
          _this.$store.dispatch("app/getSocketLog", {
            sessionKey: sessionKey
          }).then(res => {
            _this.socket.close();
            Cookie.remove('token')
            Cookie.remove('permissionList')
            sessionStorage.clear()
            _this.$Modal.warning({
              title: "提示",
              content: `<p>您的账号 ${userInfo.userName}<br/>
                           已在其他设备登录，请重新登录<br/>
                           最后一次连接时间：${res.in}<br/>
                           踢出时间：${res.out}
                        </p>`,
              onOk: () => {
                window.location.href = "/login";
              }
            })
          }).catch(error => {
            _this.socket.close();
            Cookie.remove('token')
            Cookie.remove('permissionList')
            sessionStorage.clear()
            _this.$Modal.warning({
              title: "提示",
              content: `<p>您的账号 ${userInfo.userName}<br/>已在其他设备登录，请重新登录<br/></p>`,
              onOk: () => {
                window.location.href = "/login";
              }
            })
          })
        }
      }
      this.socket.onopen = function () {
        _this.reConnectCount = 0; // 重置重连次数
        this.timer = setInterval(() => {
          _this.socket.send("ping");
        }, 30000)
      }
      this.socket.onclose = function () {
        if (_this.reConnectCount <= 10) {
          setTimeout(() => {
            _this.getLogoutMessage()
          }, 1000)
        }
        _this.reConnectCount++;
      }
      this.socket.onerror = function () {}
    },
    closeSocket() {
      if (this.socket) {
        this.socket.close();
      }
    },
    toLogin() {
      this.reLogin = false
      window.location.href = "/login";
    },
    getUserLoginStatus() {
      let timer = setInterval(() => {
        let token = Cookie.get("token");
        if (!token) {
          this.reLogin = true
          Cookie.remove('token')
          Cookie.remove('permissionList')
          sessionStorage.clear()
          clearInterval(timer)
          timer = null
          return
        }
        this.$store.dispatch("app/getUserInfoNew").then((res) => {
          // console.log("------->：", res)
          if (!res) {
            Cookie.remove('token')
            Cookie.remove('permissionList')
            sessionStorage.clear()
            timer = null
            clearInterval(timer)
            this.reLogin = true
          }
        }).catch(error => {
          // console.log("------->：", error)
          // if (error != '连接到服务器失败') {
          //   Cookie.remove('token')
          //   Cookie.remove('permissionList')
          //   sessionStorage.clear()
          //   timer = null
          //   clearInterval(timer)
          //   this.reLogin = true
          // }
        })
      }, 30000)
    }
  },
  props: ["toggle"],
  mounted() {
    setTimeout(() => {
      let userInfo = this.userInfo || Cookie.get("userInfo");
      if (userInfo) {
        userInfo = eval("(" + userInfo + ")");
      }
      this.user = Object.assign({}, userInfo)
      if (userInfo?.resetPasswordFlag != 1 || userInfo?.resetPasswordNewFlag != 1) {
        this.resetPasswordVisible = true;
      }
      this.getMessage();
      this.openPoptip();
      this.selectNoReadMessageCount()
      this.getUserLoginStatus()

      // this.getLogoutMessage()
    }, 1000)
    // this.getMessageNoticeCount();
    // let stompClient = null;
    // stompClient = Stomp.over(
    //   new SockJS("http://39.107.255.136:8081/endpoint-websocket")
    // );
    // stompClient.connect(
    //   {},
    //   frame => {
    //     //通过+from就可以指定我订阅的是我自己用户的信息
    //     stompClient.subscribe("/chat/single/" + this.currentUserID, result => {
    //       console.log(JSON.parse(result.body));
    //       this.getMessageNoticeCount();
    //     });
    //     //公共消息订阅
    //     // stompClient.subscribe('/topic/game_chat', result=> {
    //     //   console.log(JSON.parse(result.body));
    //     // });
    //   }
    // );
  },
  beforeDestroy() {
    this.closeSocket()
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    currentTab(val) { },
    '$route': {
      immediate: true,
      handler(route) {
        if (process.client) {
          const path = route.path
          if (path == '/hmtservice/plan/HM' ||                          //港澳方案
            path == '/hmtservice/plan/T' ||                             //台湾方案
            path == '/serviceSystem/newRegulation/initial-plan' ||      // 浙江初选
            path == '/serviceSystem/newRegulation/estimate-plan' ||     // 浙江模拟
            path == '/serviceSystem/newRegulation/final-plan' ||        // 浙江终稿
            path == '/serviceSystem/general-province/initial-plan' ||   // 浙江终稿
            path == '/serviceSystem/general-province/estimate-plan' ||  // 浙江终稿
            path == '/serviceSystem/general-province/final-plan' ||     // 浙江终稿
            path == '/serviceSystem/new-version/initial-plan' ||        // 浙江终稿
            path == '/serviceSystem/new-version/estimate-plan' ||       // 浙江终稿
            path == '/serviceSystem/new-version/final-plan'   ||        // 浙江终稿
            path == '/serviceSystemArt/general-province/initial-plan' ||   // 艺考通用初选
            path == '/serviceSystemArt/general-province/estimate-plan' ||  // 艺考通用模拟
            path == '/serviceSystemArt/general-province/final-plan' ||      // 艺考通用定稿
            path == '/serviceSystem/professionalGroup/initial-plan' ||
            path == '/serviceSystem/professionalGroup/estimate-plan' ||
            path == '/serviceSystem/professionalGroup/final-plan' ||
            path == '/serviceSystem/professionNew/initial-plan' ||
            path == '/serviceSystem/professionNew/estimate-plan' ||
            path == '/serviceSystem/professionNew/final-plan'
          ) {
            let t = {
              name: route.name,
              query: route.query,
              params: route.params
            }
            sessionStorage.setItem('pathForReturnRegistion', JSON.stringify(t))
            this.$store.commit("route/SET_TOGGLE", false);
          } else if (path == '/serviceSystem/volunteer' || path == '/serviceSystem/volunteer/majorGroupView' || path == '/serviceSystem/volunteer/majorGroup' ||
            path == '/serviceSystem/volunteer/majorNow' || path == '/serviceSystem/volunteer/majorNowView'
          ) {
            let  t = {}
            sessionStorage.setItem('pathForReturnRegistion', JSON.stringify(t))
          } else {
            this.$store.commit("route/SET_TOGGLE", false);
          }
          let tStr = sessionStorage.getItem('pathForReturnRegistion')
          this.t = JSON.parse(tStr) || {}
        }


      }
    }
  },
  set: {
    currentTab(val) {
      this.currentTab === val;
    }
  }
};
</script>

<style lang="less" scoped>
.layout-header {
  .header-index-right {
    float: right;
    height: 100%;
    overflow: hidden;
  }
  .header-index-left {
    float: left;
    height: 100%;
    overflow: hidden;
  }
  .header-index-action {
    display: inline-block;
    height: 100%;
    padding: 0 12px;
    cursor: pointer;
    transition: all 0.3s;
    .ivu-tabs-tab {
      min-width: 91px;
      text-align: center;
    }
    .ivu-dropdown-item {
      min-width: 160px;
      .ivu-icon + span {
        margin-left: 16px;
        font-size: 13px;
        font-weight: 500;
      }
    }
  }
  .header-index-name {
    font-size: 14px;
    margin-left: 8px;
  }
  .header-index-action > .ivu-poptip {
    .ivu-badge {
      display: inline;
    }
  }
  .text {
    padding: 15px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #cccccc;
  }
}

.modal-self {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

/* 模态窗内容样式 */
.modal-content-wrap {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
}
.title {
  font-size: 15px;
  font-weight: bold;
}
.content {
  line-height: 20px;
  font-size: 14px;
  margin: 5px;
}
.btn-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
/deep/.ivu-dropdown .ivu-select-dropdown {
  z-index: 1200;
}
/deep/ .el-dialog {
  border-radius: 10px;
}
/deep/ .el-dialog__body {
  padding: 0px 20px 20px
}
</style>
